import { RefObject, useEffect } from 'react';

// Hook
function useOnClickOutside(
  ref: RefObject<HTMLElement>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handler: (event: any) => void,
  additionalTargetsToExclude: HTMLElement[] = [],
): void {
  useEffect(
    () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const listener = (event: any): void => {
        // Do nothing if clicking ref's element or descendent elements
        if (
          ref === null ||
          !ref.current ||
          ref.current.contains(event.target) ||
          additionalTargetsToExclude.reduce((isTargetContainedInAnySoFar: boolean, target: HTMLElement) => {
            return isTargetContainedInAnySoFar || target.contains(event.target);
          }, false)
        ) {
          return;
        }

        handler(event);
      };

      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);

      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler],
  );
}

export default useOnClickOutside;
